import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import NotificationCenter from './NotificationCenter';

const Layout = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Redirect employees from admin pages to their pages
  if (user.role === 'employee') {
    const adminPaths = ['/dashboard', '/schedule', '/employees', '/payroll', '/locations', '/time-entries', '/audit-log', '/users'];
    if (adminPaths.includes(location.pathname)) {
      return <Navigate to="/my-schedule" replace />;
    }
  }

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Header Bar with Notifications */}
        <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-end px-6 shadow-sm">
          <div className="flex items-center gap-4">
            <NotificationCenter />
            <div className="text-sm text-gray-500">
              <span className="font-medium text-gray-900">{user?.name}</span>
              <span className="mx-2">•</span>
              <span className="capitalize">{user?.role?.replace('_', ' ')}</span>
            </div>
          </div>
        </header>
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
